export const types = {
  Monument: 'Monument',
  Food: 'Food',
}